<template>
    <div class="header-mobile-menu">
        <button type="button">
            <WBIcon class="header-mobile-menu__icon" name="menu" />
        </button>
    </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
    .header-mobile-menu {
        &__icon {
            font-size: 24px;
        }
    }
</style>
